import { Card, Col, Row } from "react-bootstrap";
import { motion } from "motion/react";

const CardComp = ({ data }) => {
  return (
    <div>
      {data.length > 0 ? (
        data.map((item, index) => {
          return (
            <Row className="mt-4" key={item.id}>
              <Col>
                <motion.div
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: (index + 1) * 0.2, duration: 0.5}}
                >
                  <Card className="d-flex flex-column flex-md-row">
                    <Card.Img src={item.img} className="img" />
                    <Card.Body>
                      <div className="price w-100 d-flex justify-content-between align-items-center">
                        <Card.Title className="fw-bold">
                          {item.title}
                        </Card.Title>
                        <Card.Text className="fw-bold">${item.price}</Card.Text>
                      </div>
                      <Card.Text>{item.desc}</Card.Text>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            </Row>
          );
        })
      ) : (
        <h1> لا يوجد تصنيفات</h1>
      )}
    </div>
  );
};

export default CardComp;
